// extracted by mini-css-extract-plugin
export var disk_streaming = "DiskFooter-module--disk_streaming--9cSV1";